// @ts-check
import InboundOrOutboundChooser from './InboundOrOutboundChooser';

export default InboundOrOutboundChooser;
